import React from 'react';
import { useTranslation } from 'react-i18next';
import MediaPicker from '../MediaPicker';

/**
 * Step: background music — MULTIPLE tracks (a playlist), optional.
 * `value` is an ordered array of audio media ids (empty = no music).
 *
 * ⚠️ MARKUP PORTED FROM THE PROTOTYPE's stepPicker('music') — fc-p-t/fc-p-s/
 * fc-guide, not the old ad hoc classes. The guide box answers "what happens
 * if I leave this empty?" AT the optional point, not after — no_music/
 * no_music_hint existed in both locales and were never rendered anywhere
 * before this round; this is the wiring.
 */
export default function MusicPickStep({ value = [], onChange }) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="fc-p-t">{t('cafe_wizard.step_music')}</div>
      <div className="fc-p-s">{t('cafe_wizard.music_step_subtitle')}</div>
      <div className="fc-guide">
        <b>{t('cafe_wizard.no_music')}</b> {t('cafe_wizard.no_music_hint')}
      </div>
      <MediaPicker family="music" value={value} onChange={onChange} allowUpload />
    </div>
  );
}
